export default {"src":"/_next/static/media/tasks.5d98f145.svg","height":114,"width":123,"blurWidth":0,"blurHeight":0};